export class ExprException {
  constructor(
    public position: [number, number],
    public reason: string
  ) { }
}
